import type { SkinDefinition } from '@wix/editor-elements-panel/src/adapters/types';
import {
  borderSkinParams,
  boxShadowSkinParams,
  cornerSkinParams,
  generateSkinDefaults,
  withDefaultValues,
} from '@wix/editor-elements-panel';

const skinParams = {
  ...borderSkinParams,
  ...boxShadowSkinParams,
  ...cornerSkinParams,
};

export const skinDefinition = withDefaultValues(skinParams);

export const SocialPlayerFacebookDefinitionMap = {
  'wixui.skins.SocialPlayerFacebook': skinDefinition,
} as const satisfies Record<string, SkinDefinition>;

export default generateSkinDefaults(SocialPlayerFacebookDefinitionMap);
